// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1fD_x","modal":"Modal_modal__RzVbx"};